module.exports = __webpack_public_path__ + "static/media/rocks.eb4bf36b.png";